module.exports = __webpack_public_path__ + "img/IconMedicationTherapyManagement.ff7da8a5.svg";